import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthorsPage() {
    const [authors, setAuthors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAuthors = async () => {
            try {
                const response = await axios.get(`${API}/authors`);
                setAuthors(response.data);
            } catch (error) {
                console.error('Failed to fetch authors:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchAuthors();
    }, []);

    return (
        <div className="min-h-screen" data-testid="authors-page">
            {/* Header */}
            <header className="text-center py-12 md:py-16">
                <h1 className="text-4xl md:text-5xl italic mb-8">
                    Autoři
                </h1>
                <div className="w-full max-w-4xl mx-auto h-px bg-foreground/30" />
            </header>

            {/* Authors Grid */}
            <section className="max-w-5xl mx-auto px-6 pb-24">
                {loading ? (
                    <div className="text-center py-16">
                        <p className="text-xl italic text-muted-foreground">Načítání...</p>
                    </div>
                ) : authors.length === 0 ? (
                    <div className="text-center py-16">
                        <p className="text-xl italic text-muted-foreground">
                            Zatím zde nejsou žádní autoři.
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                        {authors.map((author, index) => (
                            <Link 
                                key={author.id}
                                to={`/autor/${author.id}`}
                                className="block group text-center animate-fade-in"
                                style={{ animationDelay: `${index * 0.1}s` }}
                                data-testid={`author-card-${author.id}`}
                            >
                                {/* Portrait */}
                                <div className="mb-4">
                                    {author.portrait_url ? (
                                        <img 
                                            src={author.portrait_url} 
                                            alt={author.name}
                                            className="w-24 h-24 md:w-32 md:h-32 mx-auto rounded-full object-cover border border-foreground/20 group-hover:scale-105 transition-transform duration-300"
                                            loading="lazy"
                                        />
                                    ) : (
                                        <div className="w-24 h-24 md:w-32 md:h-32 mx-auto rounded-full bg-secondary flex items-center justify-center border border-foreground/20">
                                            <span className="text-2xl italic text-muted-foreground">
                                                {author.name.charAt(0)}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* Name */}
                                <h3 className="text-base md:text-lg uppercase tracking-wider">
                                    {author.name}
                                </h3>

                                {/* Story count */}
                                <p className="text-sm text-muted-foreground italic">
                                    {author.story_count} {author.story_count === 1 ? 'povídka' : 
                                        author.story_count >= 2 && author.story_count <= 4 ? 'povídky' : 'povídek'}
                                </p>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
